import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TDataQueryName } from '../configurations/router';
import {
  IScorecardPreview,
  IScorecardPreviewAPIResponse,
  ScorecardPreviewModel,
} from '../../shared/models/scorecard-preview.model';
import { ScorecardModel, IScorecard } from '../../shared/models/scorecard.model';
import {
  IStatementChallengeUpdateRequest,
  IStatementChallengeCreateRequest,
  IScorecardChallengeRequest,
} from '../../shared/interfaces/challenge.interface';
import { IStatement, StatementModel } from '../../shared/models/scorecard-section.model';

@Injectable({
  providedIn: 'root',
})
export class ScorecardService {
  constructor(private readonly http: HttpClient) {}

  getScorecardPreview(query: TDataQueryName, id: string): Observable<IScorecardPreview[]> {
    return this.http
      .get<IScorecardPreviewAPIResponse>(`scorecards/${query}/${id}/summaries`)
      .pipe(map(({ results }) => results.map((card) => new ScorecardPreviewModel(card))));
  }

  getScorecardDetails(query: TDataQueryName, id: string, scorecardPreview: IScorecardPreview): Observable<IScorecard> {
    return this.http
      .get<IScorecard>(
        `scorecards/${query}/${id}/scorecard/${scorecardPreview.scorecardId}/version/${scorecardPreview.version}`,
      )
      .pipe(map((response) => new ScorecardModel(response)));
  }

  updateStatementChallenge(
    query: TDataQueryName,
    id: string,
    scoreCardId: number,
    statementId: number,
    data: IStatementChallengeUpdateRequest,
  ): Observable<IStatement> {
    return this.http
      .post<{
        statement: IStatement;
      }>(`scorecards/${query}/${id}/scorecard/${scoreCardId}/challenge/${statementId}`, data)
      .pipe(map((res) => new StatementModel(res?.statement)));
  }

  executeScorecardChallenge(
    query: TDataQueryName,
    id: string,
    scorecard: IScorecard,
    payload: IScorecardChallengeRequest,
  ): Observable<IScorecard> {
    return this.http
      .post<IScorecard>(
        `scorecards/${query}/${id}/scorecard/${scorecard.scorecardId}/version/${scorecard.version}/challenge`,
        payload,
      )
      .pipe(map((res) => new ScorecardModel(res)));
  }

  createStatementChallenge(
    query: TDataQueryName,
    id: string,
    scoreCardId: number,
    data: IStatementChallengeCreateRequest,
  ): Observable<IStatement> {
    return this.http
      .post<{
        statement: IStatement;
      }>(`scorecards/${query}/${id}/scorecard/${scoreCardId}/challenge/${data.statementId}`, data)
      .pipe(map((res) => new StatementModel(res?.statement)));
  }
}
